import { render, staticRenderFns } from "./Shortlists.vue?vue&type=template&id=3edd4d72"
import script from "./Shortlists.vue?vue&type=script&lang=js"
export * from "./Shortlists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports